
import { useLocation } from 'react-router-dom';
import ASMRComponent from './ASMR/ASMRComponent';
import QAComponent from './QA/QAComponent';

const MainComponent = ({ asmrMainRef, warEleRef, marrEleRef }) => {
    const location = useLocation();
    return (
        <div>
            {
                location.search.indexOf('qna') > -1 ? <QAComponent /> : <ASMRComponent asmrMainRef={ asmrMainRef } warEleRef={ warEleRef } marrEleRef={ marrEleRef } />
            }
        </div>
    );
};

export default MainComponent;